// extracted by mini-css-extract-plugin
export default {"text":"chat_text__KjjoF","container":"chat_container__uFTxM"};